import { combineReducers } from 'redux';

import items from './items';
import selection from './selection';
import add from './add';

export default combineReducers({ items, selection, add });
